/* AURA HEADER V7.6.1 — persistent mobile header / icon utilities / search below bar */
(function () {
  var root = document.getElementById('AuraHeaderV4');
  if (!root || root.getAttribute('data-v4-init') === 'true') return;

  root.setAttribute('data-v4-init', 'true');

  var body = document.body;
  var html = document.documentElement;

  var configNode = root.querySelector('[data-aura-header-config]');
  var config = {};
  try {
    config = configNode ? JSON.parse(configNode.textContent || '{}') : {};
  } catch (error) {
    config = {};
  }

  var routes = config.routes || {};
  var strings = config.strings || {};
  var auraAnalyticsContext = {
    market: config.market || '',
    language: config.language || ''
  };

  html.classList.add('aura-header-mounted');

  function emitHeaderEvent(action, detail) {
    if (!action) return;

    var payload = Object.assign({}, auraAnalyticsContext, detail || {}, { action: action });

    document.dispatchEvent(
      new CustomEvent('aura:header:event', { detail: payload })
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: action,
        aura_header: payload
      });
    }
  }

  function renderShippingAnnouncement(attempt) {
    var target = root.querySelector('[data-aura-shipping-announcement]');
    if (!target) return;

    var shipping = config.shipping || {};
    var shippingStrings = config.shippingStrings || {};

    function currencyRate() {
      if ((shipping.currency || 'EUR') === (shipping.baseCurrency || 'EUR')) return 1;
      var value = window.Shopify && Shopify.currency ? Number(Shopify.currency.rate) : 0;
      return value > 0 ? value : 0;
    }

    function convertBaseCents(cents) {
      cents = Number(cents || 0);
      if (!cents) return 0;
      var rate = currencyRate();
      if (!rate) return null;
      if (rate === 1) return Math.round(cents * rate);
      /* Shipping CRO patch (oct. 2026): local currencies are rounded UP to a
         whole unit, never below the checkout threshold (Markets rounding). */
      return Math.ceil((cents * rate) / 100) * 100;
    }

    function escapeText(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function euroMoney(cents) {
      var euros = (Number(cents) || 0) / 100;
      var whole = euros % 1 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2
        }).format(euros);
      } catch (error) {
        return euros + ' €';
      }
    }

    function money(cents) {
      var amount = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: shipping.currency || 'EUR'
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2) + ' ' + (shipping.currency || 'EUR');
      }
    }

    if (!shipping.freeShippingEnabled) {
      target.textContent = shippingStrings.marketTerms || '';
      return;
    }

    /*
      Shipping CRO patch (oct. 2026): in a local currency the exact threshold
      cannot be computed reliably (Shopify converts and rounds at checkout).
      The rule is shown in euros, as configured, with a conversion note.
    */
    if (currencyRate() !== 1 && shippingStrings.freeFromConverted) {
      var euroAmount = euroMoney(shipping.freeThresholdBaseCents);
      target.classList.add('aura-v4-announcement__offers');
      target.innerHTML =
        '<span class="aura-v4-announcement__offer aura-v4-announcement__offer--long">' +
          escapeText(String(shippingStrings.freeFromConverted).split('__AMOUNT__').join(euroAmount)) +
        '</span>' +
        '<span class="aura-v4-announcement__offer aura-v4-announcement__offer--short">' +
          escapeText(String(shippingStrings.freeFrom || '').split('__AMOUNT__').join(euroAmount)) +
        '</span>';
      return;
    }

    var threshold = convertBaseCents(shipping.freeThresholdBaseCents);
    if (threshold === null) {
      if ((attempt || 0) < 4) {
        window.setTimeout(function () { renderShippingAnnouncement((attempt || 0) + 1); }, 80);
      } else {
        target.textContent = shippingStrings.marketTerms || '';
      }
      return;
    }

    target.textContent = String(shippingStrings.freeFrom || '')
      .split('__AMOUNT__').join(money(threshold));
  }

  renderShippingAnnouncement(0);

  var megaItems = Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-mega-item]')
  );

  var market = root.querySelector('[data-v4-market]');
  var marketOpenButtons = Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-market-open], [data-v4-mobile-market]')
  );

  var mobile = root.querySelector('[data-v4-mobile]');
  var mobileOpen = root.querySelector('[data-v4-mobile-open]');
  var mobileClose = root.querySelector('[data-v4-mobile-close]');
  var announcementBar = root.querySelector('.aura-v4-announcement');
  var primaryHeaderBar = root.querySelector('.aura-v4-bar');
  var mobileMenuOpenLabel = mobileOpen
    ? (mobileOpen.getAttribute('data-aura-menu-open-label') || mobileOpen.getAttribute('aria-label') || 'Menu')
    : 'Menu';
  var mobileMenuCloseLabel = mobileOpen
    ? (mobileOpen.getAttribute('data-aura-menu-close-label') || 'Close menu')
    : 'Close menu';

  var searchPanel = root.querySelector('[data-v4-search]');
  var searchOpen = root.querySelector('[data-v4-search-open]');
  var searchClose = root.querySelector('[data-v4-search-close]');
  var searchInput = root.querySelector('[data-v4-search-input]');
  var searchOpenLabel = searchOpen
    ? (searchOpen.getAttribute('data-aura-search-open-label') || searchOpen.getAttribute('aria-label') || 'Search')
    : 'Search';
  var searchCloseLabel = searchOpen
    ? (searchOpen.getAttribute('data-aura-search-close-label') || 'Close')
    : 'Close';

  var lockCount = 0;
  var returnFocus = null;
  var finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var edgeRevealUntil = 0;
  var previousBodyPaddingRight = '';
  var previousHtmlScrollbarGutter = html.style.scrollbarGutter || '';

  function syncAuraScrollPhysics() {
    if (
      window.AuraScrollPhysics &&
      typeof window.AuraScrollPhysics.sync === 'function'
    ) {
      window.AuraScrollPhysics.sync();
    }
  }

  function lockPage() {
    lockCount += 1;

    if (lockCount === 1) {
      syncAuraScrollPhysics();

      html.setAttribute('data-aura-scroll-suspended', 'true');
      html.style.scrollbarGutter = 'stable';

      body.setAttribute(
        'data-aura-v4-prev-overflow',
        body.style.overflow || ''
      );

      previousBodyPaddingRight = body.style.paddingRight || '';
      var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (scrollbarWidth > 0 && !(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter: stable'))) {
        var computedPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
        body.style.paddingRight = (computedPadding + scrollbarWidth) + 'px';
      }

      body.style.overflow = 'hidden';
    }
  }

  function unlockPage(force) {
    if (force) lockCount = 1;

    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0) {
      body.style.overflow =
        body.getAttribute('data-aura-v4-prev-overflow') || '';

      body.style.paddingRight = previousBodyPaddingRight;
      html.style.scrollbarGutter = previousHtmlScrollbarGutter;
      body.removeAttribute('data-aura-v4-prev-overflow');
      html.removeAttribute('data-aura-scroll-suspended');

      syncAuraScrollPhysics();
    }
  }

  /* ==========================================================
     SCROLL BEHAVIOUR
     ========================================================== */

  var ticking = false;
  var lastScrollY = window.scrollY || window.pageYOffset || 0;
  var directionTravel = 0;
  var lastDirection = 0;

  var mobileHeaderQuery =
    window.matchMedia('(max-width: 1024px)');

  function syncMobileMenuOffset() {
    if (!mobileHeaderQuery.matches) {
      root.style.removeProperty('--aura-v4-mobile-menu-top');
      return;
    }

    var announcementHeight = announcementBar
      ? Math.max(0, announcementBar.getBoundingClientRect().height)
      : 0;

    var barHeight = primaryHeaderBar
      ? Math.max(0, primaryHeaderBar.getBoundingClientRect().height)
      : 0;

    root.style.setProperty(
      '--aura-v4-mobile-menu-top',
      Math.round(announcementHeight + barHeight) + 'px'
    );
  }

  function hasOpenMega() {
    return megaItems.some(function (item) {
      return item.classList.contains('is-open');
    });
  }

  function mustKeepHeaderVisible() {
    return (
      mobileHeaderQuery.matches ||
      root.classList.contains('is-search-open') ||
      hasOpenMega() ||
      (mobile && mobile.classList.contains('is-open')) ||
      (market && market.classList.contains('is-open')) ||
      Date.now() < edgeRevealUntil
    );
  }

  function showHeader() {
    root.classList.remove('is-header-hidden');
  }

  function hideHeader() {
    if (mobileHeaderQuery.matches) return;
    root.classList.add('is-header-hidden');
  }

  function updateScrollState() {
    var y = window.scrollY || window.pageYOffset || 0;
    var delta = y - lastScrollY;

    root.classList.toggle('is-scrolled', y > 24);
    root.classList.toggle('is-deep', y > 180);

    if (mobileHeaderQuery.matches) {
      syncMobileMenuOffset();
      showHeader();
      directionTravel = 0;
      lastDirection = 0;
      lastScrollY = y;
      ticking = false;
      return;
    }

    if (mustKeepHeaderVisible() || y <= 88) {
      showHeader();
      directionTravel = 0;
      lastDirection = 0;
      lastScrollY = y;
      ticking = false;
      return;
    }

    if (Math.abs(delta) >= 0.25) {
      var direction = delta > 0 ? 1 : -1;

      if (direction !== lastDirection) {
        directionTravel = 0;
        lastDirection = direction;
      }

      directionTravel += Math.abs(delta);

      /*
       * The thresholds deliberately use accumulated real movement,
       * not wheel delta. This keeps the header compatible with
       * AURA Controlled Scroll Physics and avoids flicker while
       * the page is interpolating frame by frame.
       */
      if (direction < 0 && directionTravel >= 6) {
        showHeader();
        directionTravel = 0;
      }

      if (direction > 0 && y > 170 && directionTravel >= 34) {
        hideHeader();
        directionTravel = 0;
      }
    }

    lastScrollY = y;
    ticking = false;
  }

  function requestHeaderUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateScrollState);
  }

  window.addEventListener(
    'scroll',
    requestHeaderUpdate,
    { passive: true }
  );

  document.addEventListener('pointermove', function (event) {
    if (!finePointerQuery.matches || mobileHeaderQuery.matches) return;
    if (event.clientY <= 18 && root.classList.contains('is-header-hidden')) {
      edgeRevealUntil = Date.now() + 1200;
      showHeader();
    }
  }, { passive: true });

  if (mobileHeaderQuery.addEventListener) {
    mobileHeaderQuery.addEventListener('change', function (event) {
      showHeader();
      syncMobileMenuOffset();
      directionTravel = 0;
      lastDirection = 0;
      lastScrollY = window.scrollY || window.pageYOffset || 0;

      if (!event.matches && mobile && mobile.classList.contains('is-open')) {
        closeMobile(false);
      }
    });
  }

  syncMobileMenuOffset();

  if (typeof ResizeObserver !== 'undefined') {
    var mobileHeaderResizeObserver = new ResizeObserver(function () {
      syncMobileMenuOffset();
    });
    if (announcementBar) mobileHeaderResizeObserver.observe(announcementBar);
    if (primaryHeaderBar) mobileHeaderResizeObserver.observe(primaryHeaderBar);
  } else {
    window.addEventListener('resize', syncMobileMenuOffset, { passive: true });
  }

  window.addEventListener('orientationchange', function () {
    window.setTimeout(syncMobileMenuOffset, 80);
  });

  updateScrollState();

  /* ==========================================================
     MEGA MENUS — FINE POINTER HOVER INTENT + TOLERANCE
     ========================================================== */

  var openTimer = null;
  var closeTimer = null;
  var pointerTrail = [];
  var reportedBrandHover = new Set();

  document.addEventListener('pointermove', function (event) {
    if (!finePointerQuery.matches) return;
    pointerTrail.push({ x: event.clientX, y: event.clientY, t: Date.now() });
    if (pointerTrail.length > 4) pointerTrail.shift();
  }, { passive: true });

  function pointerHeadingTowardMega(item) {
    if (!finePointerQuery.matches || pointerTrail.length < 2) return false;
    var mega = item.querySelector('[data-v4-mega]');
    if (!mega) return false;

    var current = pointerTrail[pointerTrail.length - 1];
    var previous = pointerTrail[pointerTrail.length - 2];
    var rect = mega.getBoundingClientRect();

    if (current.y > rect.bottom + 20) return false;
    if (current.y < previous.y) return false;
    if (current.x < rect.left - 80 || current.x > rect.right + 80) return false;

    var verticalDistance = Math.max(1, rect.top - current.y);
    var horizontalVelocity = current.x - previous.x;
    var verticalVelocity = Math.max(1, current.y - previous.y);
    var projectedX = current.x + (horizontalVelocity / verticalVelocity) * verticalDistance;

    return projectedX >= rect.left - 120 && projectedX <= rect.right + 120;
  }

  function resetBrandSearchIn(container) {
    if (!container) return;
    Array.prototype.slice.call(container.querySelectorAll('[data-v4-brand-search]')).forEach(function (input) {
      if (!input.value) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function closeMegas(exceptItem) {
    megaItems.forEach(function (item) {
      if (item === exceptItem) return;

      var wasOpen = item.classList.contains('is-open');
      item.classList.remove('is-open');

      var trigger = item.querySelector('[data-v4-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (wasOpen) resetBrandSearchIn(item);
    });

    root.classList.toggle('has-open-mega', hasOpenMega());
  }

  function updateMegaHeaderState() {
    root.classList.toggle('has-open-mega', hasOpenMega());

    if (hasOpenMega()) {
      showHeader();
    }
  }

  function openMega(item, source) {
    syncAuraScrollPhysics();
    closeMegas(item);

    var wasOpen = item.classList.contains('is-open');
    item.classList.add('is-open');

    var trigger = item.querySelector('[data-v4-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (!wasOpen) {
      reportedBrandHover.clear();
      emitHeaderEvent('mega_open', {
        label: trigger ? trigger.textContent.trim() : '',
        source: source || 'unknown',
        location: 'header'
      });
    }

    updateMegaHeaderState();
  }

  function closeMega(item) {
    var wasOpen = item.classList.contains('is-open');
    item.classList.remove('is-open');

    var trigger = item.querySelector('[data-v4-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (wasOpen) resetBrandSearchIn(item);
    updateMegaHeaderState();
  }

  function scheduleMegaClose(item) {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    var delay = pointerHeadingTowardMega(item) ? 520 : 220;
    closeTimer = window.setTimeout(function () {
      closeMega(item);
    }, delay);
  }

  megaItems.forEach(function (item) {
    var trigger = item.querySelector('[data-v4-mega-trigger]');
    var mega = item.querySelector('[data-v4-mega]');

    item.addEventListener('mouseenter', function () {
      if (!finePointerQuery.matches) return;
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);

      openTimer = window.setTimeout(function () {
        openMega(item, 'hover');
      }, 110);
    });

    item.addEventListener('mouseleave', function () {
      if (!finePointerQuery.matches) return;
      scheduleMegaClose(item);
    });

    if (mega) {
      mega.addEventListener('mouseenter', function () {
        if (!finePointerQuery.matches) return;
        window.clearTimeout(closeTimer);
      });
      mega.addEventListener('mouseleave', function () {
        if (!finePointerQuery.matches) return;
        scheduleMegaClose(item);
      });
    }

    if (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeMegas();
        if (!isOpen) openMega(item, 'click');
      });

      trigger.addEventListener('focus', function () {
        openMega(item, 'keyboard');
      });
    }

    item.addEventListener('focusout', function (event) {
      var nextFocus = event.relatedTarget;
      window.setTimeout(function () {
        if (!item.contains(nextFocus) && !item.contains(document.activeElement)) {
          closeMega(item);
        }
      }, 0);
    });
  });

  /* Brand preview: hover/focus any brand, crossfade the corresponding image. */
  var brandPreview = root.querySelector('[data-v4-brand-preview-link]');
  var brandPreviewTitle = root.querySelector('[data-v4-brand-preview-title]');
  var brandPreviewFallback = root.querySelector('[data-v4-brand-preview-fallback]');
  var brandPreviewImages = Array.prototype.slice.call(root.querySelectorAll('[data-v4-brand-preview-image]'));
  var brandPreviewActiveIndex = brandPreviewImages.findIndex(function (image) { return image.classList.contains('is-active'); });
  if (brandPreviewActiveIndex < 0) brandPreviewActiveIndex = 0;

  function preloadImage(src) {
    if (!src) return Promise.resolve(false);
    return new Promise(function (resolve) {
      var image = new Image();
      image.onload = function () { resolve(true); };
      image.onerror = function () { resolve(false); };
      image.src = src;
    });
  }

  function updateBrandPreview(link, source) {
    if (!link || !brandPreview) return;
    var title = link.getAttribute('data-brand-title') || link.textContent.trim();
    var url = link.getAttribute('data-brand-url') || link.href || '#';
    var imageSrc = link.getAttribute('data-brand-image') || '';

    brandPreview.href = url;
    brandPreview.setAttribute('aria-label', title);
    if (brandPreviewTitle) brandPreviewTitle.textContent = title;

    if (!reportedBrandHover.has(title)) {
      reportedBrandHover.add(title);
      emitHeaderEvent('mega_brand_hover', {
        label: title,
        source: source || 'hover',
        location: 'brands_mega'
      });
    }

    if (!imageSrc || !brandPreviewImages.length) {
      brandPreviewImages.forEach(function (image) {
        image.classList.remove('is-active');
        image.hidden = true;
      });
      if (brandPreviewFallback) brandPreviewFallback.hidden = false;
      return;
    }

    preloadImage(imageSrc).then(function (loaded) {
      if (!loaded) return;
      var nextIndex = brandPreviewImages.length > 1 ? (brandPreviewActiveIndex === 0 ? 1 : 0) : 0;
      var next = brandPreviewImages[nextIndex];
      var current = brandPreviewImages[brandPreviewActiveIndex];
      if (!next) return;

      next.src = imageSrc;
      next.alt = title;
      next.hidden = false;
      if (brandPreviewFallback) brandPreviewFallback.hidden = true;

      window.requestAnimationFrame(function () {
        if (current && current !== next) current.classList.remove('is-active');
        next.classList.add('is-active');
        brandPreviewActiveIndex = nextIndex;
      });
    });
  }

  var brandPreviewLinks = Array.prototype.slice.call(
    root.querySelectorAll('.aura-v4-brand-mega [data-brand-title]')
  );

  brandPreviewLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!finePointerQuery.matches) return;
      updateBrandPreview(link, 'hover');
    });
    link.addEventListener('focus', function () {
      updateBrandPreview(link, 'keyboard');
    });
  });

  var brandsTrigger = root.querySelector('[aria-controls^="AuraBrandsMega-"]');
  if (brandsTrigger && brandPreviewImages.length) {
    var initialPreviewSrc = brandPreviewImages[brandPreviewActiveIndex] ? brandPreviewImages[brandPreviewActiveIndex].getAttribute('src') : '';
    brandsTrigger.addEventListener('mouseenter', function () {
      if (finePointerQuery.matches) preloadImage(initialPreviewSrc);
    });
    brandsTrigger.addEventListener('focus', function () { preloadImage(initialPreviewSrc); });
  }

  /* ==========================================================
     BRAND SEARCH
     ========================================================== */

  function normalizeString(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function initBrandSearch(input) {
    if (!input || input.getAttribute('data-v4-brand-init') === 'true') return;

    input.setAttribute('data-v4-brand-init', 'true');

    var context = input.closest('.aura-v4-brand-main, .aura-v4-mobile-panel') || root;
    var groups = Array.prototype.slice.call(
      context.querySelectorAll('.aura-v4-brand-group')
    );

    var empty = context.querySelector('[data-v4-brand-empty]');

    input.addEventListener('input', function () {
      var query = normalizeString(input.value);
      var visibleCount = 0;

      groups.forEach(function (group) {
        var links = Array.prototype.slice.call(
          group.querySelectorAll('.aura-v4-brand-link')
        );

        var groupVisible = 0;

        links.forEach(function (link) {
          var name = normalizeString(
            link.getAttribute('data-brand-name') || link.textContent
          );

          var matches = !query || name.indexOf(query) !== -1;

          link.hidden = !matches;

          if (matches) {
            groupVisible += 1;
            visibleCount += 1;
          }
        });

        group.hidden = groupVisible === 0;
      });

      if (empty) empty.hidden = visibleCount !== 0;
    });
  }

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-brand-search]')
  ).forEach(initBrandSearch);

  /* ==========================================================
     SEARCH V2 — CONVERSION FIRST
     ========================================================== */

  var searchForm = root.querySelector('[data-aura-search-form]');
  var searchInitial = root.querySelector('[data-aura-search-initial]');
  var searchResults = root.querySelector('[data-aura-search-results]');
  var searchBrandResults = root.querySelector('[data-aura-search-brand-results]');
  var searchCollectionResults = root.querySelector('[data-aura-search-collection-results]');
  var searchCollectionGroup = root.querySelector('[data-aura-search-collection-group]');
  var searchProductResults = root.querySelector('[data-aura-search-product-results]');
  var searchAllResults = root.querySelector('[data-aura-search-all-results]');
  var searchEmpty = root.querySelector('[data-aura-search-empty]');
  var searchStateLabel = root.querySelector('[data-aura-search-state-label]');
  var searchLive = root.querySelector('[data-aura-search-live]');
  var searchRecent = root.querySelector('[data-aura-search-recent]');
  var searchRecentList = root.querySelector('[data-aura-search-recent-list]');
  var searchRecentClear = root.querySelector('[data-aura-search-recent-clear]');
  var searchEmptyQuery = root.querySelector('[data-aura-search-empty-query]');
  var recentSearchStorageKey = 'aura_recent_searches_v1';

  var searchInitialLabel = strings.searchInitial || 'DISCOVER';
  var searchLoadingLabel = strings.searchLoading || 'SEARCHING…';
  var searchResultLabel = strings.searchResult || 'RESULTS';

  var searchCache = new Map();
  var searchAbortController = null;
  var searchRequestId = 0;
  var predictiveTimer = null;
  var searchDebounceMs = 150;
  var searchMinCharacters = 2;

  var searchBrandSource = Array.prototype.slice.call(
    root.querySelectorAll('.aura-v4-brand-main [data-brand-name]')
  );

  function searchEscapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getRecentSearches() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(recentSearchStorageKey) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean).slice(0, 3) : [];
    } catch (error) {
      return [];
    }
  }

  function setRecentSearches(items) {
    try {
      window.localStorage.setItem(recentSearchStorageKey, JSON.stringify(items.slice(0, 3)));
    } catch (error) {}
  }

  function rememberSearch(query) {
    query = String(query || '').trim();
    if (query.length < searchMinCharacters) return;
    var normalized = normalizeString(query);
    var items = getRecentSearches().filter(function (item) {
      return normalizeString(item) !== normalized;
    });
    items.unshift(query);
    setRecentSearches(items);
    renderRecentSearches();
  }

  function renderRecentSearches() {
    if (!searchRecent || !searchRecentList) return;
    var items = getRecentSearches();
    searchRecent.hidden = items.length === 0;
    searchRecentList.innerHTML = items.map(function (item) {
      return '<button type="button" data-aura-search-recent-item="' + searchEscapeHtml(item) + '">' + searchEscapeHtml(item) + '</button>';
    }).join('');
  }

  function setSearchEmptyState(query, empty) {
    if (!searchEmpty) return;
    searchEmpty.hidden = !empty;
    if (searchEmptyQuery) searchEmptyQuery.textContent = empty ? String(query || '').trim() : '';
    if (empty) {
      emitHeaderEvent('search_no_result', { query: String(query || '').trim(), location: 'header_search' });
    }
  }

  function setSearchLoading(loading) {
    if (!searchPanel) return;
    searchPanel.classList.toggle('is-loading', loading);
    if (searchResults) searchResults.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (searchLive) searchLive.textContent = loading ? searchLoadingLabel : '';
  }

  function showSearchInitial() {
    if (searchInitial) searchInitial.hidden = false;
    if (searchResults) searchResults.hidden = true;
    if (searchStateLabel) searchStateLabel.textContent = searchInitialLabel;
    if (searchLive) searchLive.textContent = '';
    setSearchEmptyState('', false);
    renderRecentSearches();
    setSearchLoading(false);
  }

  function showSearchResults() {
    if (searchInitial) searchInitial.hidden = true;
    if (searchResults) searchResults.hidden = false;
    if (searchStateLabel) searchStateLabel.textContent = searchResultLabel;
  }

  function abortSearchRequest() {
    if (searchAbortController && typeof searchAbortController.abort === 'function') {
      searchAbortController.abort();
    }
    searchAbortController = null;
  }

  function resetSearchExperience() {
    window.clearTimeout(predictiveTimer);
    abortSearchRequest();
    if (searchBrandResults) searchBrandResults.innerHTML = '';
    if (searchCollectionResults) searchCollectionResults.innerHTML = '';
    if (searchProductResults) searchProductResults.innerHTML = '';
    showSearchInitial();
  }

  function rankBrandMatches(query) {
    var normalizedQuery = normalizeString(query);
    if (!normalizedQuery) return [];

    return searchBrandSource
      .map(function (link) {
        var name = normalizeString(link.getAttribute('data-brand-name'));
        var score = 99;
        if (name === normalizedQuery) score = 0;
        else if (name.indexOf(normalizedQuery) === 0) score = 1;
        else if (name.indexOf(normalizedQuery) !== -1) score = 2;
        return { link: link, name: name, score: score };
      })
      .filter(function (item) { return item.score < 99; })
      .sort(function (a, b) {
        if (a.score !== b.score) return a.score - b.score;
        return a.name.length - b.name.length;
      })
      .slice(0, 5);
  }

  function renderBrandResults(query) {
    if (!searchBrandResults) return [];
    var matches = rankBrandMatches(query);

    searchBrandResults.innerHTML = matches.map(function (item) {
      var label = item.link.textContent.trim();
      return (
        '<a href="' + searchEscapeHtml(item.link.href) + '">' +
          '<span>' + searchEscapeHtml(label) + '</span>' +
          '<span aria-hidden="true">→</span>' +
        '</a>'
      );
    }).join('');

    return matches;
  }

  function getPredictiveSearchUrl(query) {
    var predictiveUrl =
      (window.AURA_THEME && window.AURA_THEME.predictiveSearchUrl)
        ? window.AURA_THEME.predictiveSearchUrl
        : (routes.predictiveSearch || '/search/suggest');

    return (
      predictiveUrl +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection' +
      '&resources[limit]=10' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&section_id=aura-predictive-search'
    );
  }

  function setAllResultsUrl(query) {
    if (!searchAllResults) return;
    searchAllResults.href = (routes.search || '/search') + '?q=' + encodeURIComponent(query) + '&type=product';
  }

  function applyPredictiveMarkup(htmlText, query, requestId) {
    if (requestId !== searchRequestId) return;

    var documentFragment = new DOMParser().parseFromString(htmlText, 'text/html');
    var responseRoot = documentFragment.querySelector('[data-aura-search-response]');
    var brandMatches = renderBrandResults(query);
    var matchedBrandNames = new Set(brandMatches.map(function (item) { return item.name; }));
    var productCount = 0;
    var collectionCount = 0;

    if (searchProductResults) searchProductResults.innerHTML = '';
    if (searchCollectionResults) searchCollectionResults.innerHTML = '';

    if (responseRoot) {
      var productSource = responseRoot.querySelector('[data-aura-search-response-products]');
      var collectionSource = responseRoot.querySelector('[data-aura-search-response-collections]');

      if (productSource && searchProductResults) {
        searchProductResults.innerHTML = productSource.innerHTML;
        productCount = searchProductResults.querySelectorAll('[data-aura-search-product]').length;
      }

      if (collectionSource && searchCollectionResults) {
        var collections = Array.prototype.slice.call(
          collectionSource.querySelectorAll('[data-aura-search-collection]')
        );

        collections.forEach(function (collectionLink) {
          var collectionName = normalizeString(collectionLink.getAttribute('data-search-name'));
          if (matchedBrandNames.has(collectionName)) return;
          searchCollectionResults.appendChild(collectionLink.cloneNode(true));
          collectionCount += 1;
        });
      }
    }

    if (searchCollectionGroup) searchCollectionGroup.hidden = !collectionCount;

    var totalResults = brandMatches.length + collectionCount + productCount;
    setSearchEmptyState(query, totalResults === 0);

    if (totalResults === 0) {
      emitHeaderEvent('header_search_zero_results', { query: query });
    }

    showSearchResults();
    setAllResultsUrl(query);
    setSearchLoading(false);
    if (searchLive) searchLive.textContent = totalResults ? String(totalResults) : '0';
  }

  function requestPredictiveSearch(query) {
    var normalizedQuery = normalizeString(query);

    if (searchCache.has(normalizedQuery)) {
      searchRequestId += 1;
      applyPredictiveMarkup(searchCache.get(normalizedQuery), query, searchRequestId);
      return;
    }

    abortSearchRequest();
    searchRequestId += 1;
    var requestId = searchRequestId;
    searchAbortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
    setSearchLoading(true);

    fetch(getPredictiveSearchUrl(query), {
      headers: { 'Accept': 'text/html' },
      signal: searchAbortController ? searchAbortController.signal : undefined
    })
      .then(function (response) {
        return response.text().then(function (text) {
          if (!response.ok) throw new Error('Predictive search failed: ' + response.status);
          return text;
        });
      })
      .then(function (text) {
        searchCache.set(normalizedQuery, text);
        applyPredictiveMarkup(text, query, requestId);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (requestId !== searchRequestId) return;

        var brandMatches = renderBrandResults(query);
        if (searchProductResults) searchProductResults.innerHTML = '';
        if (searchCollectionResults) searchCollectionResults.innerHTML = '';
        if (searchCollectionGroup) searchCollectionGroup.hidden = true;
        showSearchResults();
        setAllResultsUrl(query);
        setSearchLoading(false);
        setSearchEmptyState(query, brandMatches.length === 0);
      });
  }

  function closeSearch(restoreFocus) {
    if (!root.classList.contains('is-search-open')) return;
    root.classList.remove('is-search-open');
    if (searchPanel) searchPanel.setAttribute('aria-hidden', 'true');
    if (searchOpen) {
      searchOpen.setAttribute('aria-expanded', 'false');
      searchOpen.setAttribute('aria-label', searchOpenLabel);
    }
    window.clearTimeout(predictiveTimer);
    abortSearchRequest();
    unlockPage();
    if (restoreFocus && searchOpen) searchOpen.focus({ preventScroll: true });
  }

  function openSearchPanel() {
    showHeader();
    syncAuraScrollPhysics();
    closeMegas();
    closeMobile(false);
    closeMarket(false);
    syncMobileMenuOffset();
    root.classList.add('is-search-open');
    emitHeaderEvent('header_search_open', { location: 'header' });
    if (searchPanel) searchPanel.setAttribute('aria-hidden', 'false');
    if (searchOpen) {
      searchOpen.setAttribute('aria-expanded', 'true');
      searchOpen.setAttribute('aria-label', searchCloseLabel);
    }
    lockPage();
    if (!searchInput || !searchInput.value.trim()) showSearchInitial();
    window.setTimeout(function () {
      if (searchInput) searchInput.focus({ preventScroll: true });
    }, 80);
  }

  if (searchOpen) {
    searchOpen.addEventListener('click', function () {
      if (root.classList.contains('is-search-open')) closeSearch(true);
      else openSearchPanel();
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', function () { closeSearch(true); });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      if (!searchInput || !searchInput.value.trim()) {
        event.preventDefault();
        if (searchInput) searchInput.focus();
        return;
      }

      rememberSearch(searchInput.value.trim());
      emitHeaderEvent('header_search_submit', {
        query: searchInput.value.trim(),
        location: 'header_search'
      });
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(predictiveTimer);
      var query = searchInput.value.trim();

      if (query.length < searchMinCharacters) {
        resetSearchExperience();
        return;
      }

      renderBrandResults(query);
      showSearchResults();
      setAllResultsUrl(query);

      predictiveTimer = window.setTimeout(function () {
        requestPredictiveSearch(query);
      }, searchDebounceMs);
    });
  }

  if (searchRecentClear) {
    searchRecentClear.addEventListener('click', function () {
      setRecentSearches([]);
      renderRecentSearches();
    });
  }

  if (searchRecentList) {
    searchRecentList.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-aura-search-recent-item]') : null;
      if (!button || !searchInput) return;
      var query = button.getAttribute('data-aura-search-recent-item') || button.textContent.trim();
      searchInput.value = query;
      emitHeaderEvent('search_recent_click', { query: query, location: 'header_search' });
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus({ preventScroll: true });
    });
  }

  if (searchPanel) {
    searchPanel.addEventListener('click', function (event) {
      var resultLink = event.target.closest ? event.target.closest('[data-aura-search-results] a[href]') : null;
      if (!resultLink || !searchInput) return;
      rememberSearch(searchInput.value.trim());
    });
  }

  function getSearchKeyboardItems() {
    if (!searchResults || searchResults.hidden) return [];
    return Array.prototype.slice.call(
      searchResults.querySelectorAll('a[href], button:not([disabled])')
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true';
    });
  }

  if (searchPanel) {
    searchPanel.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var items = getSearchKeyboardItems();
      if (!items.length) return;

      var active = document.activeElement;
      var index = items.indexOf(active);

      if (active === searchInput) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          items[0].focus({ preventScroll: true });
        }
        return;
      }

      if (index === -1) return;
      event.preventDefault();

      if (event.key === 'ArrowDown') {
        items[Math.min(index + 1, items.length - 1)].focus({ preventScroll: true });
      } else if (index === 0 && searchInput) {
        searchInput.focus({ preventScroll: true });
      } else {
        items[Math.max(index - 1, 0)].focus({ preventScroll: true });
      }
    });
  }

  renderRecentSearches();

  function cartAriaLabel(count) {
    count = Number(count || 0);
    if (count === 0) return strings.cartZero || 'Cart, 0 items';
    if (count === 1) return strings.cartOne || 'Cart, 1 item';
    return (strings.cartManyPrefix || 'Cart, ') + count + (strings.cartManySuffix || ' items');
  }

  function updateSearchCartCount(cart) {
    if (!cart) return;
    var count = Number(cart.item_count || 0);
    Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (countNode) {
      countNode.textContent = count > 99 ? '99+' : String(count);
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-aura-cart-open]')).forEach(function (button) {
      button.setAttribute('aria-label', cartAriaLabel(count));
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-aura-cart-badge]')).forEach(function (badge) {
      badge.hidden = count === 0;
    });
  }

  function openCartAfterSearchAdd() {
    closeSearch(false);
    if (typeof window.openAuraCart === 'function') {
      window.openAuraCart();
      return;
    }
    var cartTrigger = document.querySelector('[data-aura-cart-open]');
    if (cartTrigger) window.setTimeout(function () { cartTrigger.click(); }, 60);
  }

  function refreshCartAfterSearchAdd() {
    var refreshPromise = Promise.resolve();

    if (typeof window.auraRefreshCart === 'function') {
      try { refreshPromise = Promise.resolve(window.auraRefreshCart()); }
      catch (error) { refreshPromise = Promise.resolve(); }
    }

    return refreshPromise
      .then(function () {
        return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart) {
          updateSearchCartCount(cart);
          document.dispatchEvent(new CustomEvent('aura:cart:changed', { detail: { cart: cart } }));
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return cart;
      });
  }

  function ensureSearchAddError(button) {
    var card = button.closest('[data-aura-search-product], .aura-search-v2-product');
    if (!card) return null;

    var errorNode = card.querySelector('[data-aura-search-add-error]');
    if (!errorNode) {
      errorNode = document.createElement('div');
      errorNode.className = 'aura-search-v2-product__error';
      errorNode.setAttribute('data-aura-search-add-error', '');
      errorNode.setAttribute('role', 'status');
      errorNode.setAttribute('aria-live', 'polite');
      errorNode.setAttribute('aria-atomic', 'true');
      var actions = card.querySelector('.aura-search-v2-product__actions') || card;
      actions.appendChild(errorNode);
    }
    return errorNode;
  }

  function classifyCartAddError(message) {
    var normalized = normalizeString(message);
    if (
      normalized.indexOf('sold out') !== -1 ||
      normalized.indexOf('epuise') !== -1 ||
      normalized.indexOf('inventory') !== -1 ||
      normalized.indexOf('stock') !== -1 ||
      normalized.indexOf('available') !== -1
    ) {
      return strings.quickAddStockError || 'This size has just sold out.';
    }
    if (
      normalized.indexOf('variant') !== -1 ||
      normalized.indexOf('taille') !== -1 ||
      normalized.indexOf('size') !== -1
    ) {
      return strings.quickAddUnavailableError || 'Unable to add this size.';
    }
    return strings.quickAddError || 'Something went wrong. Try again.';
  }

  root.addEventListener('click', function (event) {
    var sizeButton = event.target.closest ? event.target.closest('.aura-search-v2-product__size') : null;
    if (!sizeButton || !searchPanel || !searchPanel.contains(sizeButton)) return;
    emitHeaderEvent('header_search_size_select', {
      query: searchInput ? searchInput.value.trim() : '',
      label: sizeButton.textContent.trim(),
      variant_id: sizeButton.getAttribute('data-variant-id') || undefined,
      location: 'header_search'
    });
  });

  root.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-aura-search-add]') : null;
    if (!button || !searchPanel || !searchPanel.contains(button)) return;

    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var errorNode = ensureSearchAddError(button);
    if (errorNode) errorNode.textContent = '';

    var originalLabel = button.textContent;
    var addingLabel = button.getAttribute('data-adding-label');
    var addedLabel = button.getAttribute('data-added-label');
    var card = button.closest('[data-aura-search-product], .aura-search-v2-product');
    var productId = card ? (card.getAttribute('data-product-id') || card.getAttribute('data-aura-product-id')) : null;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    if (addingLabel) button.textContent = addingLabel;

    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            var err = new Error(payload && payload.description ? payload.description : 'Cart add failed');
            err.payload = payload;
            throw err;
          }
          return payload;
        });
      })
      .then(function () {
        if (addedLabel) button.textContent = addedLabel;
        emitHeaderEvent('header_search_add_to_cart', {
          query: searchInput ? searchInput.value.trim() : '',
          product_id: productId || undefined,
          variant_id: variantId,
          location: 'header_search'
        });
        return refreshCartAfterSearchAdd();
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = originalLabel;
        openCartAfterSearchAdd();
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
        button.textContent = originalLabel;

        if (errorNode) {
          errorNode.textContent = classifyCartAddError(error && error.message ? error.message : '');
        }
      });
  });

  /* ==========================================================
     MOBILE MENU
     ========================================================== */

  var mobilePanels = Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-mobile-panel]')
  );
  var mobilePanelScroll = Object.create(null);
  var currentMobilePanelName = 'root';

  function panelByName(name) {
    return mobilePanels.find(function (panel) {
      return panel.getAttribute('data-v4-mobile-panel') === name;
    }) || null;
  }

  function setMobilePanel(name, focusPanel) {
    var previousName = currentMobilePanelName;
    var previousPanel = panelByName(previousName);
    if (previousPanel) mobilePanelScroll[previousName] = previousPanel.scrollTop;

    var activePanel = null;

    mobilePanels.forEach(function (panel) {
      var isCurrent = panel.getAttribute('data-v4-mobile-panel') === name;
      panel.classList.toggle('is-current', isCurrent);
      if (isCurrent) activePanel = panel;
    });

    currentMobilePanelName = name;

    Array.prototype.slice.call(
      root.querySelectorAll('[data-v4-mobile-panel-open]')
    ).forEach(function (button) {
      button.setAttribute(
        'aria-expanded',
        button.getAttribute('data-v4-mobile-panel-open') === name && name !== 'root' ? 'true' : 'false'
      );
    });

    if (activePanel) {
      window.requestAnimationFrame(function () {
        activePanel.scrollTop = Number(mobilePanelScroll[name] || 0);
      });
    }

    if (previousName === 'brands' && name !== 'brands') {
      resetBrandSearchIn(previousPanel);
    }

    if (name !== 'root' && name !== previousName) {
      emitHeaderEvent('mobile_panel_open', { panel: name, location: 'mobile_menu' });
    }

    if (focusPanel && activePanel) {
      window.setTimeout(function () {
        var focusTarget = activePanel.querySelector(
          '[data-v4-mobile-back], [data-v4-brand-search], a[href], button:not([disabled])'
        );
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }, 60);
    }
  }

  function openMobileMenu() {
    showHeader();
    syncAuraScrollPhysics();
    closeMegas();
    closeSearch(false);
    closeMarket(false);

    if (!mobile) return;

    returnFocus = mobileOpen || document.activeElement;
    setMobilePanel('root', false);
    syncMobileMenuOffset();

    root.classList.add('is-mobile-menu-open');
    mobile.classList.add('is-open');
    mobile.setAttribute('aria-hidden', 'false');
    emitHeaderEvent('mobile_menu_open', { location: 'header' });

    if (mobileOpen) {
      mobileOpen.setAttribute('aria-expanded', 'true');
      mobileOpen.setAttribute('aria-label', mobileMenuCloseLabel);
    }

    lockPage();

    window.setTimeout(function () {
      var firstItem = mobile.querySelector(
        '[data-v4-mobile-panel="root"] a[href], [data-v4-mobile-panel="root"] button'
      );
      if (firstItem) firstItem.focus({ preventScroll: true });
    }, 60);
  }

  function closeMobile(restoreFocus) {
    if (!mobile || !mobile.classList.contains('is-open')) return;

    root.classList.remove('is-mobile-menu-open');
    mobile.classList.remove('is-open');
    mobile.setAttribute('aria-hidden', 'true');

    if (mobileOpen) {
      mobileOpen.setAttribute('aria-expanded', 'false');
      mobileOpen.setAttribute('aria-label', mobileMenuOpenLabel);
    }

    setMobilePanel('root', false);
    resetBrandSearchIn(mobile);
    mobilePanelScroll = Object.create(null);
    currentMobilePanelName = 'root';
    mobilePanels.forEach(function (panel) { panel.scrollTop = 0; });
    unlockPage();

    if (restoreFocus && returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus({ preventScroll: true });
    }
  }

  if (mobileOpen) {
    mobileOpen.addEventListener('click', function () {
      if (mobile && mobile.classList.contains('is-open')) {
        closeMobile(true);
      } else {
        openMobileMenu();
      }
    });
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', function () {
      closeMobile(true);
    });
  }

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-mobile-panel-open]')
  ).forEach(function (button) {
    button.addEventListener('click', function () {
      setMobilePanel(
        button.getAttribute('data-v4-mobile-panel-open'),
        true
      );
    });
  });

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-mobile-back]')
  ).forEach(function (button) {
    button.addEventListener('click', function () {
      setMobilePanel('root', true);
    });
  });

  /*
   * Direct mobile navigation links should release the scroll lock
   * immediately. This also makes same-page / history navigation cleaner.
   */
  Array.prototype.slice.call(
    root.querySelectorAll('.aura-v4-mobile a[href]')
  ).forEach(function (link) {
    link.addEventListener('click', function () {
      closeMobile(false);
    });
  });

  /* ==========================================================
     MARKET / LANGUAGE
     ========================================================== */

  var localizationForm = document.getElementById('AuraV4LocalizationForm');
  var countryInput = document.getElementById('AuraV4CountryCode');
  var languageInput = document.getElementById('AuraV4LanguageCode');

  function openMarket(trigger) {
    showHeader();
    syncAuraScrollPhysics();
    closeMegas();
    closeSearch(false);
    closeMobile(false);

    if (!market) return;

    returnFocus = trigger && trigger.closest && trigger.closest('.aura-v4-mobile')
      ? (mobileOpen || trigger)
      : (trigger || document.activeElement);

    market.classList.add('is-open');
    market.setAttribute('aria-hidden', 'false');

    setCountryMoreOpen(false);

    marketOpenButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    lockPage();

    window.setTimeout(function () {
      var first = market.querySelector(
        '[data-v4-country], [data-v4-country-filter], [data-v4-language]'
      );

      if (first) first.focus();
    }, 70);
  }

  function closeMarket(restoreFocus) {
    if (!market || !market.classList.contains('is-open')) return;

    market.classList.remove('is-open');
    market.setAttribute('aria-hidden', 'true');

    marketOpenButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    unlockPage();

    if (restoreFocus && returnFocus && typeof returnFocus.focus === 'function') {
      returnFocus.focus();
    }
  }

  marketOpenButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      openMarket(button);
    });
  });

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-market-close]')
  ).forEach(function (button) {
    button.addEventListener('click', function () {
      closeMarket(true);
    });
  });

  var marketReassurances = Array.prototype.slice.call(root.querySelectorAll('[data-aura-market-reassurance], [data-aura-market-reassurance-global]'));
  var marketReassurance = marketReassurances[0] || null;
  var marketReassuranceTimer = null;
  var marketReassuranceStorageKey = 'aura_market_reassurance_v1';

  function showMarketReassurance(payload) {
    if (!marketReassurances.length || !payload) return;
    var prefix = strings.marketReassurancePrefix || 'Delivery';
    var message = prefix + ' ' + (payload.name || '') + ' · ' + (payload.currency || '');
    marketReassurances.forEach(function (node) {
      node.textContent = message;
      node.classList.add('is-visible');
    });
    window.clearTimeout(marketReassuranceTimer);
    marketReassuranceTimer = window.setTimeout(function () {
      marketReassurances.forEach(function (node) { node.classList.remove('is-visible'); });
    }, 1600);
  }

  try {
    var savedMarketReassurance = JSON.parse(window.sessionStorage.getItem(marketReassuranceStorageKey) || 'null');
    if (savedMarketReassurance) {
      window.sessionStorage.removeItem(marketReassuranceStorageKey);
      window.setTimeout(function () { showMarketReassurance(savedMarketReassurance); }, 260);
    }
  } catch (error) {}

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-country]')
  ).forEach(function (button) {
    button.addEventListener('click', function () {
      if (!countryInput || !localizationForm) return;

      countryInput.value = button.getAttribute('data-v4-country');

      try {
        window.sessionStorage.setItem(marketReassuranceStorageKey, JSON.stringify({
          name: button.getAttribute('data-v4-country-name') || button.textContent.trim(),
          currency: button.getAttribute('data-v4-country-currency') || ''
        }));
      } catch (error) {}

      emitHeaderEvent('header_market_change', {
        label: button.textContent.trim(),
        market: countryInput.value,
        location: 'market_drawer'
      });

      localizationForm.submit();
    });
  });

  Array.prototype.slice.call(
    root.querySelectorAll('[data-v4-language]')
  ).forEach(function (button) {
    button.addEventListener('click', function () {
      if (!languageInput || !localizationForm) return;

      languageInput.value = button.getAttribute('data-v4-language');

      emitHeaderEvent('header_language_change', {
        label: button.textContent.trim(),
        language: languageInput.value,
        location: 'market_drawer'
      });

      localizationForm.submit();
    });
  });

  var countryMoreButton =
    root.querySelector(
      '[data-v4-country-more]'
    );

  var countryMorePanel =
    root.querySelector(
      '[data-v4-country-more-panel]'
    );

  function setCountryMoreOpen(open) {
    if (
      !countryMoreButton ||
      !countryMorePanel
    ) {
      return;
    }

    countryMoreButton.setAttribute(
      'aria-expanded',
      open ? 'true' : 'false'
    );

    countryMorePanel.hidden =
      !open;

    if (
      open &&
      countryFilter
    ) {
      window.setTimeout(
        function () {
          countryFilter.focus();
        },
        40
      );
    }
  }

  if (
    countryMoreButton &&
    countryMorePanel
  ) {
    countryMoreButton.addEventListener(
      'click',
      function () {
        setCountryMoreOpen(
          countryMorePanel.hidden
        );
      }
    );
  }


  var countryFilter = root.querySelector('[data-v4-country-filter]');

  if (countryFilter) {
    countryFilter.addEventListener('input', function () {
      var query = normalizeString(countryFilter.value);

      var countryScope = countryMorePanel || root;
      var countries = Array.prototype.slice.call(
        countryScope.querySelectorAll('[data-v4-country-search]')
      );

      var visible = 0;

      countries.forEach(function (country) {
        var name = normalizeString(
          country.getAttribute('data-v4-country-search')
        );

        var matches = !query || name.indexOf(query) !== -1;

        country.hidden = !matches;

        if (matches) visible += 1;
      });

      var empty = countryMorePanel
        ? countryMorePanel.querySelector('[data-v4-country-empty]')
        : root.querySelector('[data-v4-country-empty]');
      if (empty) empty.hidden = visible !== 0;
    });
  }

  /* ==========================================================
     MARKET — OUTSIDE CLICK
     ========================================================== */

  document.addEventListener('pointerdown', function (event) {
    if (
      !market ||
      !market.classList.contains('is-open')
    ) {
      return;
    }

    var panel =
      market.querySelector(
        '.aura-v4-market-panel'
      );

    var clickedTrigger =
      event.target.closest &&
      event.target.closest(
        '[data-v4-market-open], [data-v4-mobile-market]'
      );

    if (clickedTrigger) {
      return;
    }

    if (
      panel &&
      panel.contains(event.target)
    ) {
      return;
    }

    closeMarket(true);
  });


  /* ==========================================================
     CART STATE / ACCESSIBILITY
     ========================================================== */

  var auraCartDrawer = document.getElementById('auraCartDrawer');

  function syncCartExpandedState() {
    if (!auraCartDrawer) return;
    var isOpen =
      auraCartDrawer.classList.contains('is-open') ||
      auraCartDrawer.getAttribute('aria-hidden') === 'false';

    Array.prototype.slice.call(root.querySelectorAll('[data-aura-cart-open]')).forEach(function (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  if (auraCartDrawer && typeof MutationObserver !== 'undefined') {
    syncCartExpandedState();
    new MutationObserver(syncCartExpandedState).observe(auraCartDrawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  Array.prototype.slice.call(root.querySelectorAll('[data-aura-cart-open]')).forEach(function (button) {
    button.addEventListener('click', function () {
      if (mobile && mobile.classList.contains('is-open')) {
        closeMobile(false);
      }
      emitHeaderEvent('header_cart_open', { location: 'header' });
    });
  });

  Array.prototype.slice.call(root.querySelectorAll('[data-aura-wishlist-hub]')).forEach(function (wishlistLink) {
    wishlistLink.addEventListener('click', function () {
      emitHeaderEvent('header_wishlist_click', { href: wishlistLink.href, location: 'header' });
    });
  });

  if (searchPanel) {
    searchPanel.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;

      var action = 'header_search_result_click';
      if (link.matches('[data-aura-search-all-results]')) action = 'header_search_view_all';
      else if (link.closest('[data-aura-search-brand-results]')) action = 'header_search_brand_click';
      else if (link.closest('[data-aura-search-collection-results]')) action = 'header_search_collection_click';

      emitHeaderEvent(action, {
        query: searchInput ? searchInput.value.trim() : '',
        label: link.textContent.trim(),
        href: link.href,
        location: 'header_search'
      });
    });
  }

  root.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || searchPanel && searchPanel.contains(link)) return;

    if (link.classList.contains('aura-v4-brand-link') || link.closest('.aura-v4-featured-brands')) {
      emitHeaderEvent('header_brand_click', { label: link.textContent.trim(), href: link.href, location: 'header' });
      return;
    }

    if (link.hasAttribute('data-aura-category-link') || link.closest('.aura-v4-category-grid') || link.closest('.aura-v4-mobile-category-list')) {
      emitHeaderEvent('header_category_click', { label: link.textContent.trim(), href: link.href, location: 'header' });
      return;
    }

    if (link.hasAttribute('data-aura-journal-link')) {
      emitHeaderEvent('header_journal_click', { label: link.textContent.trim(), href: link.href, location: 'header' });
      return;
    }

    if (link.closest('.aura-v4-archive-mega') || link.closest('.aura-v4-mobile-archive-list')) {
      emitHeaderEvent('header_archive_click', { label: link.textContent.trim(), href: link.href, location: 'header' });
    }
  });

  /* ==========================================================
     GLOBAL ESC / OUTSIDE
     ========================================================== */

  function getActiveModalContainer() {
    if (
      root.classList.contains(
        'is-search-open'
      ) &&
      searchPanel
    ) {
      return searchPanel;
    }

    if (
      mobile &&
      mobile.classList.contains(
        'is-open'
      )
    ) {
      /*
       * The close control now lives in the persistent .aura-v4-bar,
       * outside the drawer node. Trap focus inside the header root so
       * hamburger/X, logo, search, bag and the visible menu panel all
       * remain keyboard reachable.
       */
      return root;
    }

    if (
      market &&
      market.classList.contains(
        'is-open'
      )
    ) {
      return (
        market.querySelector(
          '.aura-v4-market-panel'
        ) ||
        market
      );
    }

    return null;
  }

  function trapModalFocus(event) {
    if (
      event.key !==
      'Tab'
    ) {
      return;
    }

    var container =
      getActiveModalContainer();

    if (!container) {
      return;
    }

    var focusables =
      Array.prototype.slice.call(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (element) {
        var style = window.getComputedStyle(element);
        var hiddenAncestor = element.closest ? element.closest('[aria-hidden="true"]') : null;
        var announcementAncestor = element.closest ? element.closest('.aura-v4-announcement') : null;

        if (
          announcementAncestor &&
          announcementAncestor.getBoundingClientRect().height < 2
        ) {
          return false;
        }

        return (
          !element.hidden &&
          !hiddenAncestor &&
          element.getAttribute(
            'aria-hidden'
          ) !==
            'true' &&
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          (
            element.offsetWidth > 0 ||
            element.offsetHeight > 0
          )
        );
      });

    if (!focusables.length) {
      event.preventDefault();
      return;
    }

    var first =
      focusables[0];

    var last =
      focusables[
        focusables.length - 1
      ];

    if (
      event.shiftKey &&
      document.activeElement ===
        first
    ) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (
      !event.shiftKey &&
      document.activeElement ===
        last
    ) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener(
    'keydown',
    trapModalFocus
  );

  /* ==========================================================
     CONSERVATIVE PREFETCH — FINE POINTER ONLY
     ========================================================== */

  var prefetchedUrls = new Set();
  var prefetchCount = 0;
  var maxPrefetches = 8;

  function prefetchUrl(url) {
    if (!url || prefetchCount >= maxPrefetches || prefetchedUrls.has(url)) return;
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.origin !== window.location.origin || parsed.href === window.location.href) return;
      prefetchedUrls.add(parsed.href);
      prefetchCount += 1;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = parsed.href;
      link.as = 'document';
      document.head.appendChild(link);
    } catch (error) {}
  }

  Array.prototype.slice.call(
    root.querySelectorAll('.aura-v4-nav a[href], .aura-v4-brand-link[href], .aura-v4-featured-brands a[href], .aura-v4-category-grid a[href]')
  ).forEach(function (link) {
    var timer = null;
    link.addEventListener('mouseenter', function () {
      if (!finePointerQuery.matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { prefetchUrl(link.href); }, 220);
    });
    link.addEventListener('mouseleave', function () { window.clearTimeout(timer); });
    link.addEventListener('focus', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { prefetchUrl(link.href); }, 320);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    closeMegas();

    if (root.classList.contains('is-search-open')) {
      closeSearch(true);
      return;
    }

    if (mobile && mobile.classList.contains('is-open')) {
      closeMobile(true);
      return;
    }

    if (market && market.classList.contains('is-open')) {
      closeMarket(true);
    }
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target)) {
      closeMegas();
      closeSearch(false);
    }
  });

  /* close mega when link clicked */
  Array.prototype.slice.call(
    root.querySelectorAll('.aura-v4-mega a')
  ).forEach(function (link) {
    link.addEventListener('click', function () {
      closeMegas();
    });
  });

  var initialCartBadge = root.querySelector('[data-aura-cart-badge]');
  if (initialCartBadge) {
    initialCartBadge.hidden = Number(initialCartBadge.textContent || 0) === 0;
  }

  /* ==========================================================
     SHOPIFY THEME EDITOR
     ========================================================== */

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector('#AuraHeaderV4')) {
      root.classList.remove('is-scrolled');
      root.classList.remove('is-header-hidden');
    }
  });

})();
